export const SUPPORT_EMAIL = "support@variant3d.io";

export const SUPPORT_EMAIL_HREF = `mailto:${SUPPORT_EMAIL}`;

export const SALES_EMAIL = "loop@variant3d.io";

export const SALES_EMAIL_HREF = `mailto:${SALES_EMAIL}`;

export const SUPPORT_PHONE = "818-889-6280 ext. 715";

export const SUPPORT_PHONE_HREF = "tel:+18188896280";

export const ADDRESS_LINES = ["327 Latigo Canyon Rd.", "Malibu, CA 90265"] as const;

export const CONTACT_ANSWER_PHONE_SUFFIX = ` or call ${SUPPORT_PHONE}.`;

export const DISCORD_INVITE_URL = "https://discord.gg/HRtxMANp52";

export const DISCORD_CTA_LABEL = "Join our Discord";
